import React from 'react'
import styles from './EdofSection4.module.css'


const EdofSection4 = () => {
    return (
        <div className={styles.containerBoxMain}>
            <div className={styles.containerBox}>
                <div className={styles.container}>
                    <div className={styles.LeftSection}>
                        <div className={styles.Part1}>
                            <h1>A <b>New </b>Class <br /> of Presbyopic <br /> Correction</h1>
                            <h3>Continuous Focus <br /> Without Multifocal Zones</h3>

                        </div>

                        <div className={styles.FDAOutcomes}>
                            <div className={styles.fdaClinical}>
                                <h3>FDA Clinical Outcomes</h3>
                            </div>
                            <div className={styles.studyDesign}><h4>Study Design</h4></div>
                            <p className={styles.ptext}>1-day crossover <br />
                                Randomized/Double masked <br />
                                78 subjects <br />
                                Randomly assigned lens first <br />
                                30-minute washout before crossover<br />
                                Three US sites</p>
                            <div className={styles.resultDiv}>
                                <h3>Results:</h3>
                                <p>Statistically significant increase in depth of focus:<br />
                                    +0.78 D vs control (p = 0.0002)</p>
                            </div>
                            <div>

                                <div className={styles.edofSection}>


                                </div>
                                <div className={styles.section}>


                                </div>

                                {/* Shape Div*/}
                                <div className={styles.shapeDiv}>
                                    <div className={styles.edof}>
                                        <h4>Deseyne <span className='diffentFamily'>(</span>EDOF<span className='diffentFamily'>)</span> vs Control</h4>
                                    </div>
                                    <div className={styles.section}>
                                        <h4>Intermediate Vision 66 cm</h4>
                                        <p>
                                            DCIVA: 0.01 logMAR (~20/20) vs 0.16 logMAR (~20/29)
                                        </p>

                                        <h5 className={styles.resultTitle}>Result:</h5>
                                        <p className={styles.result}>1.5-line improvement</p>
                                        <p className={styles.result}>2.2 line in ≥60 years</p>
                                        <h4 className={styles.nearVision}>Near Vision <span className={styles.FontChange}>40</span> cm</h4>
                                        <p>
                                            DCNVA: 0.20 logMAR (~20/31) vs 0.35 logMAR (~20/45)
                                        </p>

                                        <h5 className={styles.resultTitle}>Result:</h5>
                                        <p className={styles.result2}>1.6-line improvement</p>
                                        <p className={styles.result2}>2.0-line in ≥60 years</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className={styles.RightSection}>
                        <img src='/Images/talking_women.webp' alt='talking_women' />
                        <img src='/Images/in_gym.webp' alt='in_gym' />
                        <img src='/Images/Image-Woman.webp' alt='Image-Woman' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EdofSection4
